/* Prashanth's Adivasi — theme interactions */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    var track = root.querySelector('[data-pa-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) { root.querySelectorAll('[data-pa-ui]').forEach(function (e) { e.style.display = 'none'; }); return; }
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pa-dot]'));
    var dur = parseInt(root.dataset.paInterval || '6000', 10);
    var i = 0, timer = null;

    function paint() {
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-on', n === i);
        if (n === i) { d.style.setProperty('--pa-hero-dur', dur + 'ms'); }
        d.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    }
    function go(n) { i = (n + slides.length) % slides.length; paint(); restart(); }
    function next() { go(i + 1); }
    function restart() { if (timer) clearInterval(timer); if (!RM && root.dataset.paAuto !== 'false') timer = setInterval(function () { i = (i + 1) % slides.length; paint(); }, dur); }

    root.querySelectorAll('[data-pa-next]').forEach(function (b) { b.addEventListener('click', next); });
    root.querySelectorAll('[data-pa-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    document.addEventListener('visibilitychange', function () { document.hidden ? (timer && clearInterval(timer)) : restart(); });

    // touch swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 46) { dx < 0 ? next() : go(i - 1); }
      x0 = null;
    }, { passive: true });

    paint(); restart();
  }

  /* ---------- Announcement rotator ---------- */
  function initAnn(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-pa-ann-item]'));
    if (!items.length) return;
    var i = 0, dur = parseInt(root.dataset.paInterval || '4500', 10), timer = null;
    function paint() { items.forEach(function (el, n) { el.classList.toggle('is-on', n === i); }); }
    function go(n) { i = (n + items.length) % items.length; paint(); }
    root.querySelectorAll('[data-pa-ann-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
    root.querySelectorAll('[data-pa-ann-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
    paint();
    if (items.length > 1 && !RM) timer = setInterval(function () { go(i + 1); }, dur);
  }

  /* ---------- Mobile menu ---------- */
  function initMob() {
    var drawer = document.querySelector('[data-pa-mob]');
    if (!drawer) return;
    function open() { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-pa-mob-open]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-pa-mob-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Sticky header shadow ---------- */
  function initStuck() {
    var h = document.querySelector('[data-pa-hdr]');
    if (!h) return;
    var on = function () { h.classList.toggle('is-stuck', window.scrollY > 8); };
    on(); window.addEventListener('scroll', on, { passive: true });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.pa-reveal:not(.is-in)'));
    if (!els.length) return;
    if (RM) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    // Opt in to the hidden start state only once JS is confirmed running.
    document.documentElement.classList.add('js-reveal');
    var ticking = false;
    function check() {
      ticking = false;
      var limit = window.innerHeight * 0.94;
      for (var i = els.length - 1; i >= 0; i--) {
        var r = els[i].getBoundingClientRect();
        if (r.top < limit && r.bottom > -200) { els[i].classList.add('is-in'); els.splice(i, 1); }
      }
      if (!els.length) {
        window.removeEventListener('scroll', request);
        window.removeEventListener('resize', request);
      }
    }
    function request() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    window.addEventListener('load', request);
    check();
    // Safety net: if anything is still hidden after 6s of no scrolling, show it.
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 6000);
  }

  /* ---------- Quick add to cart ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pa-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-pa-add');
      if (!id) return;
      var label = btn.innerHTML;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          refreshCartCount();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (err) { } }
          setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1600);
        })
        .catch(function () {
          btn.textContent = 'Try again';
          setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1600);
        });
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-pa-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.style.display = c.item_count > 0 ? '' : 'none';
        });
      }).catch(function () { });
  }

  /* ---------- Sticky mobile add-to-cart ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-pa-sticky-atc]');
    if (!bar) return;
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    var anchor = document.querySelector('.product-form__buttons, .product-form__submit');
    if (!form) { bar.remove(); return; }
    bar.querySelector('[data-pa-sticky-submit]').addEventListener('click', function () {
      var s = form.querySelector('[type=submit], .product-form__submit');
      if (s) s.click();
    });
    if (!anchor || !('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function (en) {
      bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Newsletter inline feedback ---------- */
  function initNews() {
    document.querySelectorAll('[data-pa-news]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var b = f.querySelector('button[type=submit]');
        if (b) { b.disabled = true; b.textContent = 'Subscribing…'; }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pa-hero]').forEach(initHero);
    document.querySelectorAll('[data-pa-ann]').forEach(initAnn);
    initMob(); initStuck(); initReveal(); initQuickAdd(); initStickyAtc(); initNews();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init inside the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pa-hero]').forEach(initHero);
    e.target.querySelectorAll('[data-pa-ann]').forEach(initAnn);
    initMob(); initStuck(); initReveal(); initStickyAtc();
  });
})();
